/* eslint-disable react/no-string-refs */
import {Text, Tooltip} from "@blueprintjs/core";
import styled from "@emotion/styled";
import {WarningIcon} from "../../../common/icons";
import {TManifestEnhanced} from "../../../common/types";

export interface JobColHeaderRendererParams {
  manifest: TManifestEnhanced | undefined;
}

const getWarningMessage = (message: string | undefined) => {
  if (!message || message === "Success") return "";
  return message;
};

const ETAColHeaderRenderer = ({manifest}: JobColHeaderRendererParams) => {
  let warningContent: string | JSX.Element = getWarningMessage(manifest?.etaMessage);
  if (manifest && warningContent.startsWith("The driver completed stop")) {
    const messageParts = warningContent.split(/(#\d+)/g) || [];
    warningContent = (
      <div>{messageParts.map((part, index) => (/^#\d+$/.test(part) ? <strong key={index}>{part}</strong> : part))}</div>
    );
  }

  return (
    <Container data-testid="eta-col-header">
      <Left>
        <Text ellipsize>ETA</Text>
        {warningContent && (
          <Tooltip content={warningContent} popoverClassName="manifest-header-warning-tooltip" placement="top">
            <WarningIcon />
          </Tooltip>
        )}
      </Left>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const Left = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;

export default ETAColHeaderRenderer;
